module.exports = function() {
  return new Worker(__webpack_public_path__ + "817fdda66422f6b76a8a.worker.js");
};